import { Locale } from '@klokhuis/core/Intl/types';
import { logger } from '@klokhuis/core/Logger';

const localeCache: Partial<Record<Locale, Record<string, string>>> = {}; // Cache for locales

export async function loadLocale(
  locale: Locale,
): Promise<Record<string, string>> {
  logger.info(`loading locale ${locale}`);

  const data = await import(`./${locale}.json`);

  const messages = data.default || data;

  logger.info(
    `Loaded ${Object.keys(messages).length} keys for locale ${locale}`,
  );
  if (messages['agent_partnership.title']) {
    logger.info(`Key 'agent_partnership.title' is present in ${locale}`);
  } else {
    logger.warn(`Key 'agent_partnership.title' is MISSING in ${locale}`);
  }

  localeCache[locale] = messages;

  return messages;
}
